export default {
    rojo: '#D7202C',
    rojoClaro: '#F23361',
    verde: '#2DB997',
    verdeClaro: '#2DB997',
    naranja: '#FF9446',
    celeste: '#9AC8FF',
    celesteClaro: '#F4F6F9',
    morado: '#7371FF',
    grisMedio: '#8A8A8A',
    grisClaro: '#E2E2E2',
    grisOscuro: '#737373',
    azulClaro: '#316ACD',
    azul: '#003591',
    amarillo: '#FADB00', //Justin
    MoradoOscuro: '#6D6AF6', //Justin
    grisMedioClaro: '#BDBDBD', //Justin
    naranjaClaro: '#FFF1E7'
};